//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

// custom pages
import Logo from "assets/img/consent-logo.png";
import ContentImage from "assets/img/21DS1776-Thrive Current Vs Future.jpg";
import { consentStyles } from "./styles";
import auth from "apis/auth/auth";
import Congratulations from "assets/img/Congradulations.png";
import Loader from "components/Loader/CenteredLoader";

// material-ui
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";

export default function TransferConsent() {
  const { oneWebTransfer, cancelTransfer, getTransferStatus } = auth();
  const classes = consentStyles();
  const location = useLocation();

  const param = new URLSearchParams(location.search);
  const token = param.get("token");

  const [loading, setLoading] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const [usLink, setusLink] = useState("");

  useEffect(() => {
    handleGetTransferStatus();
  }, []);

  const handleGetTransferStatus = async () => {
    try {
      setLoading(true);
      let res = await getTransferStatus(token);
      if (res && res?.type == "success") {
        if (res?.redirectionURL) {
          setRedirectUrl(res?.redirectionURL);
        }
        setMessage(res?.message);
        setStatus(res?.status);
        setusLink(res?.usLink)
        setLoading(false);
        return;
      }
      if (res && res?.message) {
        setMessage(res?.message);
      } else {
        setMessage("Unauthorized");
      }
      setStatus("Unauthorized");
      setLoading(false);
    } catch (e) {
      console.log({ e });
    }
  };

  const handleTransfer = async () => {
    try {
      let values = {
        token: token,
      };
      let res = await oneWebTransfer(values);

      if (res && res?.type == "success") {
        setRedirectUrl(res?.redirectionURL);
        setMessage(res?.message);
        setStatus("Processed");
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const handleCancel = async () => {
    try {
      let values = {
        token: token,
      };
      let res = await cancelTransfer(values);
      if (res && res?.type == "success") {
        let redirectionUrl;
        let referrerUrl = res?.referrerUrl;
        if (referrerUrl.includes("?")) {
          redirectionUrl = `${res?.referrerUrl}&shipto=${res?.encrypted}`;
        } else {
          redirectionUrl = `${res?.referrerUrl}?shipto=${res?.encrypted}`;
        }
        window.location.replace(redirectionUrl);
        return;
      }
    } catch (e) {
      console.log({ e });
    }
  };

  return (
    <div className={classes.mainDiv}>
      <img src={Logo} style={{ marginTop: 50, marginBottom: 50 }} alt="logo" />
      <Loader Loading={loading}>
        {status === "Inprocessed" && (
          <Card className={classes.card}>
            <div className={classes.divText}>Acknowledgement</div>
            <div className={classes.divSubText}>
              Thrive Rewards is a discount program intended for private dental
              practice and small group practices. For questions regarding
              eligibility, please contact Thrive Rewards Customer Service at
              1-800-888-6684. By enrolling in Henry Schein Thrive Rewards, you
              have read, understood and agree to the{" "}
              <a
                target="_blank"
                href={usLink}
              >
                [Terms & Conditions]
              </a>{" "}
              of this program and acknowledge that your points will be
              transferred from Connection Awards to Thrive Rewards at the
              standard point value. For an overview of the Henry Schein Thrive
              Rewards program rules, point value, and benefits{" "}
              <a
                target="_blank"
                href={usLink}
              >
                click here.
              </a>
            </div>
            <Button
              className={classes.cancelBtn}
              onClick={() => {
                handleCancel();
              }}
            >
              Cancel Transfer
            </Button>
            <Button
              className={classes.enrollBtn}
              onClick={async () => {
                let value = await handleTransfer();
                if (value) {
                  sessionStorage.setItem("enrolled", true);
                }
              }}
            >
              Transfer
            </Button>
          </Card>
        )}
        {status === "Processed" && (
          <div>
            <img src={Congratulations} alt="" width="50%" />
            <div className={classes.message}>{message}</div>
            <Button
              className={classes.goBackBtn}
              onClick={() => {
                window.location.replace(redirectUrl);
              }}
            >
              Go Back
            </Button>
          </div>
        )}
        {status === "Unauthorized" && (
          <div>
            <div className={classes.message}>{message}</div>
          </div>
        )}
      </Loader>
      {status === "Inprocessed" && (
        <img
          src={ContentImage}
          alt="consent-img"
          style={{ marginBottom: 20 }}
          width="75%"
        />
      )}
    </div>
  );
}
